<template>
  <v-container fluid style="overflow: hidden !important;">
   <v-layout row wrap v-if="status_login === 'T'" class="hidden-sm-and-down">
      <v-flex sm12 md12 lg12 xl12 >
        <div class="chatboxnonselect">
      <v-tooltip bottom>
          <img slot="activator" src="/static/img/icons/home_markettopThin.svg" style="border: 2px solid rgb(37, 98, 175);border-radius: 15px; margin-top: 10px;margin-left: 10px;width: 70px; float: left; cursor: pointer;" @click="home()">
        <span>Go to home merket</span>
      </v-tooltip>

          <v-layout align-center justify-center row fill-height>

            <div style="text-align: center;">
              <iframe id="url_market" style="visibility:visible;width: 49vw; height: calc(100vh - 85px);" frameborder='0' :src="url" allow="geolocation *;" sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-navigation">

                <!-- <form target="_blank" method="PUT" action=""/> -->
              </iframe>
            </div>
          </v-layout>
          <br>

          <!--  -->
        </div>
      </v-flex>
      </v-layout>
      </v-container>
</template>

<script>
import { Decode } from '@/services'
import { sync } from 'vuex-pathify'

export default {
  data () {
    return {
      url: '',
      status_login: '',
      token: ''
    }
  },
  created () {
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.status_login = decoded['status_login']
    this.token = decoded['tokenuser']
    this.getMarketPlace()
  },
  computed: {
    ...sync('*')
  },
  methods: {
    checkredirectpath () {
      // if ("https://portal.thaidotcompayment.co.th")
      var url_market = document.getElementById('url_market').src
      // console.log(url_market)
      if (url_market.includes('https://portal.thaidotcompayment.co.th')) {
        // console.log("url_market")
      }
    },
    home () {
      // this.$router.push('/chat/service/market')
      this.linkmarket = ''
      this.getMarketPlace()
    },
    getMarketPlace () {
      this.axios.post(process.env.APImanage +'/v2/get_url_locallife', {tokenuser: this.token, env: process.env.Market_env}).then((response) => {
      // this.axios.post('https://chat-manage.one.th:8997/v2/get_url_locallife', {tokenuser: this.token, env: 'production'}).then((response) => {
        // console.log(response.data.url)
        if (response.data.status === 'success') {
          if (this.$route.query.goto == 'link_market' && this.linkmarket) {
            this.url = this.linkmarket.replace('{auth_token}', response.data.access_token)
            document.getElementById('url_market').src = this.url
          } else {
            this.url = response.data.url + "?access_token=" + response.data.access_token
            document.getElementById('url_market').src = this.url
          }
        }
      }, () => {
        this.Progress.ListChat = false
        console.log('error')
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.container{
  padding: 0px !important;
}
.fixed-content {
    min-height:100%;
    /*position:fixed;*/
    overflow-y:scroll;
    overflow-x:hidden;
}
.content {
      padding: 0px 0px 0px !important;
}
>>>.chatboxnonselect{
    width: 100%;
    min-width: 10vw;
    height: calc(100vh - 64px);
    background-color:white;
    overflow-y: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/service/market.vue